exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#ir-search-tab-2 .ir-cck-tip{width:210px!important;margin-top:-30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/search/FormElements/Tip/Tip.less
// module id = 1631
// module chunks = 0